<template>
  <div>
    <v-dialog v-model="imageDialog" max-width="700">
      <v-card>
        <v-card-title>{{ $t('image_data') }} {{ title || "" }}</v-card-title>
        <v-card-text class="py-5">
          <v-img :src="imgUrl" aspect-ratio="1"></v-img>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="imageDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PageName",
  computed: {
    imageDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {},
  data() {
    return {};
  },
  props: {
    value: Boolean,
    imgUrl: String,
    title: String
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
